import { questionGenerator } from './questionGenerator';
import { FlashcardQuestion, QuestionTypeEnum } from '@/models/Question';

export function flashcardQuestionGenerator(
  question?: Partial<FlashcardQuestion>,
): FlashcardQuestion {
  return {
    frontContent: { 'pt-br': '', en: '' },
    backContent: { 'pt-br': '', en: '' },
    showFrontOnBack: false,
    ...questionGenerator(question),
    ...question,
    type: QuestionTypeEnum.FLASHCARD,
  };
}
